/**
 * @typedef {import('./types')} Types
 */

export class PressImagePreview {

    /**
     * @type {HTMLElement}
     */
    target;

    /**
     * @type {Types.Options|undefined}
     */
    options = undefined;

    /**
     * @type {string}
     */
    mimeType;

    /**
     * @type {string}
     */
    fileUrl;

    /**
     * @type {Types.Labels}
     */
    labels;

    /**
     * @param {HTMLElement} target
     * @param {Options|undefined} options
     */
    constructor(target, options = undefined) {
        this.target = target;
        this.options = options;
        this.mimeType = target.dataset.mimetype;
        this.fileUrl = target.dataset.fileurl;

        this.labels = this.options?.labels ?? {
            download: 'Download',
            overview: 'Pressimages overview',
        };

        this.initializePopup();
    }

    initializePopup() {
        const type = this.getPopupType();
        if (type === null) {
            return;
        }

        const fileurl = this.fileUrl;
        const overviewUrl = this.options?.overviewUrl;

        const popupOptions = {
            autoFocusLast: false,
            type: type,
            callbacks: {
                open: function () {
                    $('.mfp-pressimages-download', this.content).attr('href', fileurl);
                    if (overviewUrl) {
                        $('.mfp-pressimages-overview', this.content).attr('href', overviewUrl);
                    }
                }
            }
        };

        if (type === 'image') {
            popupOptions.image = {
                markup: `
                    <div class="mfp-figure latest-photos-teaser">
                      <div class="mfp-pressimages-actions">
                        <a href="" class="mfp-pressimages-download" download=""><span>${this.labels.download}</span></a>
                        ${overviewUrl ? `<a href="" class="mfp-pressimages-overview"><span>${this.labels.overview}</span>${this.labels.overview}</a>` : ''}
                      </div>
                      <div class="mfp-close"></div>
                      <div class="mfp-img-wrapper">
                            <div class="mfp-img"></div>
                      </div>
                      <div class="mfp-bottom-bar">
                        <div class="mfp-title"></div>
                        <div class="mfp-counter"></div>
                      </div>
                    </div>
                `
            };
        }

        if (type === 'inline') {
            popupOptions.items = {
                src: `
                    <div class="mfp-figure latest-photos-teaser">
                      <div class="mfp-pressimages-actions">
                        <a href="" class="mfp-pressimages-download" download=""><span>${this.labels.download}</span></a>
                        ${overviewUrl ? `<a href="" class="mfp-pressimages-overview"><span>${this.labels.overview}</span>${this.labels.overview}</a>` : ''}
                      </div>
                      <div class="mfp-close"></div>
                      <div class="mfp-video">
                        <video controls>
                            <source src="${this.fileUrl}" type="${this.mimeType}" />
                        </video>
                      </div>
                      <div class="mfp-bottom-bar">
                        <div class="mfp-title"></div>
                        <div class="mfp-counter"></div>
                      </div>
                    </div>
                `
            };
        }

        $('a', this.target).magnificPopup(popupOptions);
    }

    /**
     * Get the type for magnific popup.
     *
     * @returns {string|null}
     */
    getPopupType() {
        const mediaType = this.mimeType?.split('/')[0];
        let type;

        switch(mediaType) {
            case 'video':
                type = 'inline';
                break;
            case 'image':
                type = 'image';
                break;
            default:
                type = null;
        }

        return type;
    };
}

